import { useNavigate } from 'react-router-dom';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import getOrgLogo from '../../../utils/helpers/getOrgLogo';
import tempEdgeLogo from '../../../assets/static/tempEge-logo-sm.png';

const NavBrand = ({ to, testId }) => {
  const navigate = useNavigate();
  const { tempedgeTranslator } = useTempEdgeTranslator();
  const logoSrc = getOrgLogo() || tempEdgeLogo;

  return (
    <button
      className="te-nav-brand"
      onClick={() => navigate(to)}
      aria-label={tempedgeTranslator('com.tempedge.msg.public.nav.home')}
      data-testid={testId}
    >
      <img src={logoSrc} alt="TempEdge" className="te-nav-logo" />
    </button>
  );
};

export default NavBrand;
